import styled, { css } from 'styled-components';
import media from '../../base/media';

export const Wrapper = styled.div`
	transition: opacity 300ms ease;

	${({ loading }) => loading && css`
		opacity: 0.6;
		pointer-events: none;
	`}
`;

export const ApartmentBoxWrapper = styled.div`

`;

export const BasicInfoWrapper = styled.div`
	${media.desktopSmall`
		max-width: 50rem;
	`}
`;

export const BasicInfoForm = styled.div`
	margin-top: 3rem;

	${media.tablet`
		margin-top: 6rem;
	`}
`;

export const RenterInfoForm = styled.div`
	margin-top: 3rem;

	${media.tablet`
		margin-top: 4rem;
	`}
`;

export const AdditionalInfoForm = styled.div`
	margin-top: 3rem;
	${media.tablet`
		margin-top: 4rem;
	`}
`;
		
export const CreditRatingWrapper = styled.div`
	margin-top: 3rem;
	max-width: 100rem;
`;

export const ButtonWrapper = styled.div`
	margin-top: 5rem;
	text-align: center;

	${media.tablet`
		display: flex;
		justify-content: flex-end;
		align-items: center;
		text-align: inital;
	`}
`;
